export enum Summary_Types {
    POST = 'POST',
    FILE = 'FILE',
    COMMENT = 'COMMENT',
    MENTION = 'MENTION',
}

export interface Summary {
    id: number;
    accountName: string;
    createdBy: number;
    createdAt: string;
    createdByName: string;
    modifiedBy: number;
    modifiedAt: string;
    modifiedByName: string;
    userProfileImage: string;
    content: string;
    contentType: Summary_Types;
    fileName: string;
    kind: any;
    fileProperties: string;
    displayContent?: any;
    imgUrl?: string;
    shortDescription?: any;
    mentionType: string;
}

export interface TabDetails {
    name: string;
    tabName: string;
    method: any;
    searchTextData: string;
    oldSearchText: string;
    data: Summary[];
    isAllDataLoaded: boolean;
    pageCountDivider: number;
}